
import {
  POST,
  GET,
  GETPDF,
  FORMDATA
} from '@/axios/axios'

export const services = {
  RechargeList: (param) => {//充值管理-充值记录列表
    return GET('/backend/accountRecharge/queryByPage', param);
  },
  ExportRecharge: (param, rsType) => {//充值管理-充值记录列表导出
    return GETPDF('/backend/accountRecharge/export', param, rsType);
  },
  updateRemark: (param) => {//充值记录-充值备注变更
    return GET('/backend/accountRecharge/updateRechargeRemark', param);
  },
  RechargeAudit: (param) => {//充值管理-充值审核
    return FORMDATA('/backend/accountRecharge/checked', param);
  },
  getRechargeReceipt: (param) => {//充值管理-获取充值的电子回单
    return GET('/backend/accountRecharge/getRechargeReceipt', param);
  },
  rechargeNoRefList: (param) => {//充值管理-待确认充值记录
    return POST('/backend/accountRecharge/accountMinShengRechargeNoRefList', param);
  },
  minShnegCheck: (param) => {//充值管理-待确认充值记录-账户充值
    return POST('/backend/accountRecharge/minShnegCheck', param);
  },
  PDF: (param, rsType) => { //pdf查看接口
    return GETPDF('/backend/custom/preview', param, rsType);
  },
  pdfDownload: (param) => { //pdf下载接口
    return '/backend/custom/downAgree?customId=';
  },
  //uuid接口
  uuid: () => {
    return GET('http://localhost:8081/backend/upload/getUUID');
  },
  getBigAgeCheck: () => { // 认证管理，获取认证最大年龄预警
    return GET('/backend/dataDict/getSettingInfo?key=PERSON_SETTINGS_BIG_AGE_CHECK');
  },
  personalList: (param) => {// 认证管理个人认证列表
    return GET('/backend/custom/queryAuthenticateByPage', param);
  },
  personalListExport: (param, rsType) => { //  个人认证导出
    return GETPDF('/backend/custom/export', param, rsType);
  },
  authenticate: (param) => {// 认证管理个人认证编辑列表
    return POST('/backend/custom/authenticate', param);
  },
  perAdopt: (param) => {//认证管理个人认证通过列表
    return GET('/backend/custom/checked', param);
  },
  execlPersons: (param) => {//认证管理个人认证批量表格导入
    return POST('/backend/custom/personsExcel', param);
  },
  savePersons: (param) => {//认证管理个人认证-单条新增
    return POST('/backend/custom/savePersons', param);
  },
  updatePerson: (param) => {//认证管理个人认证-个人绑定商户接口
    return POST('/backend/custom/updateMerchantAndPerson', param);
  },
  initDestroy: (param) => {//认证管理注销申请
    return POST('/backend/user/initiateDestroy', param);
  },
  createPersonFileUrl: (param) => {//认证管理个人认证后台上传文件
    return POST('/backend/custom/createPersonFileUrl', param);
  },
  findPersonFileUrlList: (param) => {//认证管理个人认证协议文件列表
    return GET('/backend/custom/findPersonFileUrlList', param);
  },
  deletePersonFileUrl: (param) => {//认证管理 个人认证协议文件删除,设置默认
    return GET('/backend/custom/deletePersonFileUrl', param);
  },
  informEdit: (param) => {//通知管理修改/开票管理-开票类目管理新增/编辑
    return POST('/backend/dataDict/save', param);
  },
  BillingRecords: (param) => {//开票管理-开票记录列表
    return GET('/backend/billApplyRecord/queryInvoicingManagementByPage', param);
  },
  SubmitModify: (param) => {//开票管理-开票记录-查看修改提交
    return POST('/backend/billApplyRecord/updateBillApplyRecord', param);
  },
  AuditStatus: (param) => {//开票管理-开票记录-开票审核状态修改
    return POST('/backend/billApplyRecord/checked', param);
  },
  BillingCategory: (param) => {//开票管理-开票类目管理列表
    return GET('/backend/dataDict/queryByPage', param);
  },
  BillingCategoryExport: (param, rsType) => { // 开票类目导出
    return GETPDF('/backend/dataDict/dataDictExport', param, rsType);
  },
  BillingCateDelete: (param) => {//开票管理-开票类目管理删除
    return GET("/backend/dataDict/deleteDataDict", param);
  },
  BillingRecordExport: (param, rsType) => { // 开票记录导出
    return GETPDF("/backend/billApplyRecord/queryInvoicingManagementByExport", param, rsType);
  },
  UploadBillFile: (param) => { // 开票记录-上传发票
    return POST("/backend/billApplyRecord/uploadBillFile", param);
  },
  DeleteBillFile: (param) => {//开票管理-开票记录-删除上传发票
    return POST('/backend/billApplyRecord/deleteBillFile', param);
  },
  UpReOpenInvoicing: (param) => {//开票管理-开票记录-重开发票
    return POST('/backend/billApplyRecord/backendReApplyForInvoicing', param);
  },
  GetReOpenInvoicing: (param) => {//开票管理-开票记录-重开发票获取数据
    return GET('/backend/billApplyRecord/getBackendApplyBillInfo', param);
  },
  ApplyInvoice: (param) => {    // 发票管理-发票申请列表-单击申请发票
    return GET('/backend/billApplyRecord/queryCustomInfo', param)
  },
  UpdateInvoiceDeduct: (param) => {//开票管理-未开票明细数据-作废待开票金额
    return POST('/backend/billApplyRecord/updateInvoicedAmountForDeduct', param);
  },
  QueryApproveBillData: (param) => { // 开票管理-商户可开票数据
    return GET("/backend/billApplyRecord/queryApproveBillData", param);
  },
  QueryBillDataExport: (param, rsType) => { // 开票管理-商户可开票数据导出
    return GETPDF("/backend/billApplyRecord/queryApproveBillDataExport", param, rsType);
  },
  RechargeGroundList: (param) => { // 开票管理-商户可开票数据
    return GET("/backend/accountRecharge/findRechargeBackgroundList", param);
  },
  RechargeGroundExport: (param, rsType) => { // 开票管理-商户可开票数据导出
    return GETPDF("/backend/accountRecharge/findRechargeBackgroundListExport", param, rsType);
  },
  updateOperate: (param) => { // 开票管理-开票特殊处理：作废/红冲
    return POST("/backend/billApplyRecord/updateAbnormalOperate", param);
  },
  AgentFinancial: (param) => {//财务管理-代理商财务管理
    return GET('/backend/custom/agentFinancialManagement', param);
  },
  AgentFinancialExport: (param, rsType) => { // 代理商财务管理 导出
    return GETPDF('/backend/custom/agentFinancialManagementExport', param, rsType);
  },
  AgentFlowLists: (param) => {//财务管理-代理商流水
    return GET('/backend/accountBalanceRecord/agentFinancialSerial', param);
  },
  AgentFlowListsExport: (param, rsType) => {
    return GETPDF('/backend/accountBalanceRecord/agentFinancialSerialExport', param, rsType);
  },
  AgentPlusDeduction: (param) => {//财务管理-代理商加扣款
    return FORMDATA('/backend/accountBalanceRecord/changeMoney', param);
  },
  merchantFinancial: (param) => {//财务管理-商户财务管理
    return GET('/backend/account/merchantFinancialManagement', param);
  },
  contractMerchant: (param) => {//监管管理-合同-商户列表
    return GET('/backend/custom/regulatedMerchant', param);
  },
  ContractList: (param) => {//监管管理-合同-自由职业者列表
    return GET('/backend/custom/professional', param);
  },
  InvoicesdFist: (param) => {//监管管理-发票列表
    return GET('/backend/billApplyRecord/regulatoryInvoice', param);
  },
  invoiceDetailsList: (param) => {//监管管理-发票查看详情
    return GET('/backend/billApplyRecord/InvoiceDetails', param);
  },
  MerchantList: (param) => {//监管管理-任务-商户列表
    return GET('/backend/orderMain/merchantTask', param);
  },
  FreelancersList: (param) => {//监管管理-任务-自由职业者列表
    return GET('/backend/taskReceiveDetail/professionalTask', param);
  },
  taskDetailsList: (param) => {//监管管理-任务详情列表
    return GET('/backend/orderMain/taskDetails', param);
  },
  taskPaymentOrder: (param) => {//监管管理-查看支付订单
    return GET('/backend/orderMain/paymentOrder', param);
  },
  CapitalMerchants: (param) => {//监管管理-资金商户列表
    return GET('/backend/orderMain/merchantFunds', param);
  },
  CapitalFree: (param) => {//监管管理-资金自由职业者列表
    return GET('/backend/accountPaymentDetail/professionalFunds', param);
  },
  taskView: (param) => {//监管管理-任务验收单预览
    return GET('/backend/taskPublish/taskView', param);
  },
  DistributionList: (param) => {  // 代理商月结分润列表
    return GET('/backend/settleAccountsRecord/queryByPage', param);
  },
  closedListExport: (param, rsType) => { // 代理商月结分润导出
    return GETPDF('/backend/settleAccountsRecord/export', param, rsType);
  },
  merchantSetPage: (param) => {  // 商户月结分润列表
    return GET('/backend/settleAccountsRecord/merchantSettleByPage', param);
  },
  merchantSetExport: (param, rsType) => { // 商户月结分润导出
    return GETPDF('/backend/settleAccountsRecord/merchantSettleByExport', param, rsType);
  },
  ShareProfitGrant: (param) => {//分润管理-季结分润 发放接口
    return POST('/backend/settleAccountsRecord/issue', param);
  },
  seasonalByPage: (param) => {  // 季结分润列表
    return GET('/backend/settleAccountsRecord/querySeasonalByPage', param);
  },
  queryByRecord: (param) => {//提现管理-提现记录列表
    return GET('/backend/cashOutRecord/queryByPage', param);
  },
  recordListExport: (param, rsType) => {
    return GETPDF('/backend/cashOutRecord/export', param, rsType);
  },
  recordGrant: (param) => {//提现管理-提现记录 发放接口
    return GET('/backend/cashOutRecord/checked', param);
  },
  updateCash: (param) => {//提现管理-提现设置编辑
    return POST('/backend/cashOutRecord/dls/updateCash', param);
  },
  listPaymentInfo: (param) => {// 后台收款方式列表
    return GET('/backend/account/backend/listPaymentInfo', param)
  },
  rechargeBack: (param) => {// 充值退回
    return POST('/backend/accountRecharge/rechargeBack', param)
  },
  uploadReceipt: (param) => {// 上传充值退还凭证
    return POST('/backend/accountRecharge/uploadRechargeBackReceipt', param)
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/authentication.js